<template>
  <div v-if="image">
    <RevLink
      v-if="!isCartLocked && link"
      :aria-label="title"
      class="cursor-pointer"
      tabindex="-1"
      target="_blank"
      :to="link"
    >
      <Illustration :alt="title" :src="image" />
    </RevLink>

    <Illustration v-else :alt="title" :src="image" />
  </div>
</template>

<script lang="ts" setup>
import { inject } from 'vue'

import type { LinkInternal } from '@backmarket/http-api'
import { RevLink } from '@ds/components/Link'

import Illustration from './Illustration.vue'

const isCartLocked = inject('isCartLocked', false)

defineProps<{
  image: string
  title: string
  link?: string | null | LinkInternal
}>()
</script>
